import PropTypes from 'prop-types';
import { WORKSPACE_CREATION_STEPS } from '../../../constants/workspaces';

const WORKSPACE_CREATION_STEPS_ARRAY = Object.values(WORKSPACE_CREATION_STEPS);

const WorkspaceCreationStepper = (props) => {
  // init
  const { step } = props;

  return (
    <div className="workspace-creation-steps">
      <span className="workspace-creation-step-counter">Step {WORKSPACE_CREATION_STEPS_ARRAY.indexOf(step) + 1} of {WORKSPACE_CREATION_STEPS_ARRAY.length}</span>
      <div className="workspace-creation-step-buttons">
        {WORKSPACE_CREATION_STEPS_ARRAY.map((stepName) => <div key={`stepper-${stepName.description}`} data-active={step === stepName} className="workspace-creation-step" />)}
      </div>
      <h3 className="workspace-creation-text">Workspace Creation</h3>
    </div>
  );
};

WorkspaceCreationStepper.propTypes = {
  step: PropTypes.symbol.isRequired,
};

export default WorkspaceCreationStepper;
